import React from 'react'

function Section09() {

  return (
    <div
      className='w-full  bg-[#D0C5AF] bg-cover bg-no-repeat bg-top relative'
    >
      <img src={process.env.PUBLIC_URL+'/images/section09_bg.png'} alt=""  className='w-full object-cover' data-aos="fade" data-aos-duration="1000"/>
      <div className=' absolute top-1/2 -translate-y-1/2 right-[8%]  w-[35%]'>
        <img src={process.env.PUBLIC_URL+'/images/section09_title.png'} alt="" className='max-w-full' data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000"/>
      </div>



    </div>
  )
}

export default Section09